import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyRoleBasedNotificationDetail: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-role-based-notifications-detail", jiraSpaEntry: "async-jira-eoc-role-based-notifications-detail" */ '@jira/eoc__role-based-notifications/src/index.tsx'
	).then((module) => module.RoleBasedNotificationDetail),
);

export const RoleBasedNotificationDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyRoleBasedNotificationDetail}
		pageId="async-jira-eoc-role-based-notifications"
		shouldShowSpinner={false}
	/>
);
